import React, { useEffect, useMemo } from 'react'
import jwtDecode from 'jwt-decode'
import { Navigate } from 'react-router-dom'
import { connect } from 'react-redux'
import { clearAuthState } from '../store/slices'

interface ProtectedRouteOwnProps {
  children: React.ReactElement
}

interface ProtectedRouteStateProps {
  token: string | null
}

interface ProtectedRouteDispatchProps {
  clearAuthState: () => void
}

type ProtectedRouteProps = ProtectedRouteOwnProps & ProtectedRouteStateProps & ProtectedRouteDispatchProps

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, token, clearAuthState }) => {
  const isAuthenticated: boolean = useMemo(() => {
    const value = token ?? localStorage.getItem('token')

    if (!value) {
      return false
    }

    try {
      const decoded: { exp: number } = jwtDecode(value)
      const currentTime = Date.now() / 1000

      return decoded.exp >= currentTime
    } catch (error) {
      console.error('Error decoding token:', error)

      return false
    }
  }, [token])

  useEffect(() => {
    if (!isAuthenticated) {
      clearAuthState()
    }
  }, [isAuthenticated])

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

const mapStateToProps = (state: any): ProtectedRouteStateProps => {
  return {
    token: state.auth.token,
  }
}

const mapDispatchToProps = (dispatch: any): ProtectedRouteDispatchProps => {
  return {
    clearAuthState: () => dispatch(clearAuthState()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute)
